import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CollectionListing from '../components/Collection/CollectionListing';
const collectionWrapper = document.querySelector('[data-collection-handle]');
const collectionContainer = document.querySelector('[data-collection-container]');
if (collectionWrapper && collectionContainer) {
    const { collectionHandle, filtersEnabled } = collectionWrapper.dataset;
    const collectionFiltersEnabled = filtersEnabled === 'true';
    const collectionMenu = window.collectionMenu;
    ReactDOM.render(React.createElement(CollectionListing, {
        collectionHandle,
        collectionMenu,
        collectionFiltersEnabled
    }), collectionContainer);
}
